import { TikTokAdsIntegrationContent } from './TikTokAdsIntegrationContent';
import { getTikTokAdsConnectService } from '../services/TikTokAdsConnectService';

export interface TikTokAdsIntegrationSectionProps {
  projectId: string;
  showHeader?: boolean;
}

export function TikTokAdsIntegrationSection({
  projectId,
  showHeader = false,
}: TikTokAdsIntegrationSectionProps) {
  return (
    <TikTokAdsIntegrationContent
      projectId={projectId}
      showHeader={showHeader}
      service={getTikTokAdsConnectService()}
    />
  );
}
